"use client";
import * as React from "react";
const SvgVerifiedRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 8-1.77-2 .24-2.63-2.62-.58L10.47.5 8 1.54 5.53.5 4.15 2.78l-2.62.58L1.77 6 0 8l1.78 2-.25 2.64 2.62.58 1.38 2.28L8 14.45l2.47 1.04 1.38-2.28 2.62-.58-.25-2.64zm-9.9 2.86L4.36 9.15a.7.7 0 0 1 0-1l.05-.06a.74.74 0 0 1 1.04 0l1.17 1.16 3.74-3.69a.74.74 0 0 1 1.04 0l.05.05a.7.7 0 0 1 0 1.01l-4.3 4.24a.76.76 0 0 1-1.05 0" }));
export {
  SvgVerifiedRound as default
};
